import React from "react";
import Flagship from "../../core/flagship";
import axios from "axios";
import { Button, Divider } from "semantic-ui-react";
import AvatarEditor from "react-avatar-editor";
import InputSlider from "react-input-slider";

export default class UserPhoto extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.getSignedUrl = this.getSignedUrl.bind(this);
    this.setEditorRef = this.setEditorRef.bind(this);
    this.savePhoto = this.savePhoto.bind(this);
    this.getSignedUrl = this.getSignedUrl.bind(this);
    this.handleSliderChange = this.handleSliderChange.bind(this);
    this.s3Url = "https://flagship-user-photos.s3.amazonaws.com";
    this.state = {
      loading: true,
      uploading: false,
      progress: 0,
      scale: 1
    };
  }

  getSignedUrl(callback) {
    let params = {
      bucket: "flagship-user-photos",
      objectName: this.props.username + ".jpg",
      contentType: "image/jpeg",
      region: "us-east-2",
      ACL: "public-read"
    };

    Flagship.get(
      "s3/sign",
      params,
      function(data) {
        callback(data.data);
      },
      function(err) {
        if (typeof console.error === "function") {
          console.error(err);
        }
      }
    );
  }

  setEditorRef(editor) {
    this.editor = editor;
  }

  dataURItoBlob(dataURI) {
    let binary = atob(dataURI.split(",")[1]);
    let array = [];
    for (let i = 0; i < binary.length; i++) {
      array.push(binary.charCodeAt(i));
    }
    return new Blob([new Uint8Array(array)], { type: "image/jpeg" });
  }

  savePhoto() {
    if (this.editor) {
      const canvas = this.editor.getImageScaledToCanvas();
      const dataUrl = canvas.toDataURL("image/jpeg");
      const blobData = this.dataURItoBlob(dataUrl);
      const fileUrl = this.props.username + ".jpg";
      let params = {
        Key: fileUrl,
        ContentType: "image/jpeg",
        Bucket: "flagship-user-photos"
      };

      let onSave = this.props.onSave;
      let userId = this.props.userId;

      this.getSignedUrl(function(url) {
        axios
          .put(url.signedUrl, blobData, params)
          .then(function(response) {
            if (response.status === 200) {
              Flagship.post(
                "save-user-photo/" + userId,
                {
                  url: fileUrl
                },
                function(response) {
                  if (response.data.success === true) {
                    Flagship.notify("Photo saved.");
                  } else {
                    Flagship.error("Failed to save photo.", 0, 0);
                  }
                }
              );

              onSave();
            } else {
              Flagship.error("Error saving photo.", 0, 0);
            }
          })
          .catch(function(err) {
            Flagship.error("Error saving photo: " + err, 0, 0);
          });
      });
    }
  }

  handleSliderChange(pos) {
    this.setState({
      scale: pos.x / 100
    });
  }

  render() {
    return (
      <div>
        <AvatarEditor
          ref={this.setEditorRef}
          image={this.props.photo}
          width={180}
          height={180}
          border={0}
          color={[0, 0, 0, 0.5]} // RGBA
          scale={this.state.scale + 1}
          rotate={0}
          crossOrigin="anonymous"
          borderRadius={90}
        />
        <InputSlider
          className="slider scale-image"
          axis="x"
          x={this.state.scale * 100}
          xmax={300}
          onChange={this.handleSliderChange}
        />
        <div className="white-text">Drag & drop to replace this photo.</div>
        <Divider />
        <Button content="Save Photo" onClick={this.savePhoto} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/user/UserPhoto.js